export const OPEN_PRIVATE_NETWORK_HOME_IDENTIFIER = 'network';
export const OPEN_PRIVATE_NETWORK_FOLDER_IDENTIFIER = 'privateNetwork.openFolder';
export const OPEN_PRIVATE_NETWORK_ENTITY_IDENTIFIER = 'privateNetwork.openEntity';
export const OPEN_PRIVATE_NETWORK_ENTITY_VERSION_IDENTIFIER = 'privateNetwork.openEntityVersion';

export const OPEN_PRIVATE_NETWORK_FOLDER_URL = 'folders/:folderId';
export const OPEN_PRIVATE_NETWORK_ENTITY_URL = 'apis/:id';
export const OPEN_PRIVATE_NETWORK_ENTITY_VERSION_URL = 'apis/:id/versions/:versionId';
export const OPEN_PRIVATE_NETWORK_HOME_URL = 'network/private';

// Explore Constants Here
export const OPEN_EXPLORE_HOME_IDENTIFIER = 'explore';
export const OPEN_EXPLORE_HOME_URL = 'explore';
export const OPEN_EXPLORE_SPOTLIGHT_IDENTIFIER = 'explore.spotlight';
export const OPEN_EXPLORE_CURATED_LIST_IDENTIFIER = 'explore.viewCuratedLists';
export const OPEN_EXPLORE_VIEW_ALL_WORKSPACES_IDENTIFIER = 'explore.viewAllWorkspaces';
export const OPEN_EXPLORE_VIEW_ALL_COLLECTIONS_IDENTIFIER = 'explore.viewAllCollections';
export const OPEN_EXPLORE_VIEW_ALL_APIS_IDENTIFIER = 'explore.viewAllAPIs';
export const OPEN_EXPLORE_VIEW_ALL_TEMPLATES_IDENTIFIER = 'explore.viewAllTemplates';
export const OPEN_EXPLORE_VIEW_ALL_TEAMS_IDENTIFIER = 'explore.viewAllTeams';
export const OPEN_EXPLORE_VIEW_ALL_WORKSPACES_WITH_CATEGORY_IDENTIFIER = 'explore.viewAllWorkspacesWithCategory';
export const OPEN_EXPLORE_VIEW_ALL_COLLECTIONS_WITH_CATEGORY_IDENTIFIER = 'explore.viewAllCollectionsWithCategory';
export const OPEN_EXPLORE_VIEW_ALL_APIS_WITH_CATEGORY_IDENTIFIER = 'explore.viewAllAPIsWithCategory';
export const OPEN_EXPLORE_VIEW_ALL_TEMPLATES_WITH_CATEGORY_IDENTIFIER = 'explore.viewAllTemplatesWithCategory';
export const OPEN_EXPLORE_VIEW_ALL_TEAMS_WITH_CATEGORY_IDENTIFIER = 'explore.viewAllTeamsWithCategory';
export const OPEN_EXPLORE_VIEW_TEMPLATE_OVERVIEW_IDENTIFIER = 'explore.openTemplateOverview';
export const OPEN_EXPLORE_VIEW_APINETWORK_ENTITY_IDENTIFIER = 'explore.openAPINetworkEntityOverview';
export const OPEN_NETWORK_IMPORT_MODAL = 'NETWORK_IMPORT';

// Migration Constants
export const OPEN_MIGRATION_STATUS_IDENTIFIER = 'migration';
export const OPEN_MIGRATION_STATUS_URL = 'network/migrate';

export const OPEN_NETWORK_IMPORT_URL = 'network/import';

// Fork collection page
export const OPEN_FORK_COLLECTION_IDENTIFIER = 'fork';
export const OPEN_FORK_COLLECTION_URL = 'fork';

export const OPEN_MANAGE_PUBLIC_ELEMENTS_IDENTIFIER = 'manage.publicElements';
export const OPEN_MANAGE_PUBLIC_ELEMENTS_URL = 'manage-public';
